import { render } from "./EntryDetails.vue?vue&type=template&id=cc888fa8&scoped=true"
import script from "./EntryDetails.vue?vue&type=script&lang=js"
export * from "./EntryDetails.vue?vue&type=script&lang=js"

import "./EntryDetails.vue?vue&type=style&index=0&id=cc888fa8&scoped=true&lang=css"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc888fa8"]])

export default __exports__